import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { http, API } from "@/lib/api";

const EXCLUDED = ["/admin", "/login", "/reimposta-password", "/accesso-email"];
const VISIT_KEY = "ananawi_visit_counted";

export const VisitTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!API) return;

    if (
      EXCLUDED.some(
        (p) => pathname === p || pathname.startsWith(p + "/")
      )
    ) {
      return;
    }

    // Una sola visita per sessione/browser tab.
    // sessionStorage sopravvive anche a refresh e Ctrl+F5.
    if (sessionStorage.getItem(VISIT_KEY)) return;

    // Segniamo subito la sessione per evitare doppi conteggi
    // durante cambi rapidi di pagina.
    sessionStorage.setItem(VISIT_KEY, "1");

    http.post("/track").catch(() => {
      // Se il tracking fallisce davvero, permetti un nuovo tentativo
      // alla prossima navigazione.
      sessionStorage.removeItem(VISIT_KEY);
    });
  }, [pathname]);

  return null;
};
